// src/socket.js
import { io } from "socket.io-client";

const BACKEND_URL =
  process.env.REACT_APP_API_URL || "https://pbposuat-backend.appsystemyou.com";
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || "/socket.io";

// สร้าง socket เพียงครั้งเดียว
export const socket = io(BACKEND_URL, {
  path: SOCKET_PATH,
  transports: ["websocket"],
});

export default socket;
